<template>
  <div class="notify-container" @click="$emit('click')">
    <div id="notify-msg" v-if="hasNotify">{{msg}}</div>
    <div id="tips" v-else>
      <icon-notice class="tip-icon"/> 冲印须知
    </div>
  </div>
</template>

<script>
import IconNotice from "./Icon/IconNotice";
export default {
  components: {IconNotice},
  props: {
    hasNotify: {
      type: Boolean,
      default: false,
    },
    msg: String,
  },
};
</script>

<style lang="scss">
.notify-container {
  width: 100%;
  height: 0.44rem;
  display: flex;
  justify-content: center;
  background: rgba(221, 232, 255, 1);
  color: #363636;
  font-size: 0.14rem;

  #tips {
    display: flex;
    justify-content: center;
    align-items: center;
    .tip-icon {
      margin-right: 0.04rem;
    }
  }
}
</style>
